'use strict';
import React, { PureComponent } from 'react';
import { createForm } from 'rc-form';
import Titulo from './Titulo';
import PanelNovedad from '../../../../Common/Components/PanelNovedad';
import ModalHistorialModificaciones from '../../HistorialModificacionCuenta/ModalHistorialModificaciones';
import ModalDatosCuentaConPunta from '../ModalDatosCuentaConPunta';
import ModalDatosCuenta from '../ModalDatosCuenta';

import NovedadesHelper from '../../../../Common/Helpers/NovedadesHelper';

class DatosGeneralesCuenta extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { data, actions, permisoModificacion, permisoConfirmacion } = this.props;
        const { guardarNovedad, actualizarNovedadEstado, editandoCampoCuenta } = actions; //VER LAS ACTIONS QUE HAY QUE BORRAR POR EL REFACTOR

        let spinner = null;

        const modalModificaciones = (
            <ModalHistorialModificaciones datosLogIntentos={data.datosCuentaGenerales.datosLogIntentos } obtenerDatosLogIntentos={actions.obtenerDatosLogIntentos} modalLogIntentos={data.modalLogIntentos} IdmodalLogIntentos={data.IdmodalLogIntentos} seccion={'datosCuentaGenerales'} listaModificaciones={data.datosCuentaGenerales.modificacionesCuenta} openModalLogIntentos={this.props.actions.openModal} openModal={this.props.actions.getLogModificaciones} />
        );
        
        const modalDatosCuentaConPunta = (<ModalDatosCuentaConPunta
                                            titulo={'Cambio de Estado'}
                                            mensajePrincipal={'¿Está seguro que desea DENEGAR la actualización?'}
                                            mensajeSecundario={'Ingrese el motivo de denegación (opcional)'}
                                            value={data.datosCuentaGenerales.valorTxtArea}
                                            valorTextArea={actions.valorTextArea}
                                            openModal={actions.openModal}
                                            denegarNovedad={actions.denegarNovedad}
                                            guardarNovedadParaDenegar={actions.guardarNovedadParaDenegar}
                                            nombreCampoModal={data.datosCuentaGenerales.novedadParaDenegar.nombreCampo}
                                        />);

        if (this.props.data.loading == true) spinner = <div className="loading" />;

        if (data && data.datosCuentaGenerales && data.datosCuentaGenerales.SucursalesCuenta) {
            return (
                <div>
                    {spinner}

                    <Titulo />
                    {data.modalInfo.mostrar && <ModalDatosCuenta titulo={data.modalInfo.titulo} mensaje={data.modalInfo.mensaje} ocultarModal={this.props.actions.ocultarModalInfo} />}
                    <PanelNovedad
                        aceptarCambios={this.props.aceptarCambios}
                        nombreCampo={'SUCUR_CUEN'}
                        data={data.datosCuentaGenerales}
                        tituloCampo={'Sucursal'}
                        valorActualDescripcion={NovedadesHelper.AsignarDescripcionPorId(data.datosCuentaGenerales.SucursalesCuenta, data.datosCuentaGenerales.SucursalId)}
                        valorActual={data.datosCuentaGenerales.SucursalId}
                        novedad={(data.datosCuentaGenerales.novedadesCuentaDatos || []).filter((n) => n.NovedadCampoCodigo == 'SUCUR_CUEN' && ![5, 7].some((e) => e == n.NovedadEstadoId))}
                        cambiarEstadoNovedad={this.props.cambiarEstadoNovedad}
                        opciones={data.datosCuentaGenerales.SucursalesCuenta}
                        codigoCampo={'SUCUR_CUEN'}
                        selectCombo={this.props.actions.selectValorCampo}
                        funcionEdicion={this.props.actions.editandoCampoCuenta}
                        guardarNovedad={guardarNovedad}
                        cambiarEstadoNovedad={this.props.actions.actualizarNovedadEstado}
                        muestraBotonHistorial={data.datosCuentaGenerales.novedadesCuentaDatos && data.datosCuentaGenerales.novedadesCuentaDatos.some((n) => n.NovedadCampoCodigo == 'SUCUR_CUEN')}
                        logHistorialCambios={this.props.actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.datosCuentaGenerales.viendoModificacionesCampo == 'SUCUR_CUEN'}
                        seccion={'datosCuentaGenerales'}
                        funcionLimpiarStore={this.props.actions.limpiarStoreComponente}
                        permisoConfirmacion={permisoConfirmacion}
                        permisoModificacion={permisoModificacion}
                        openModal={this.props.actions.openModal}
                        guardarNovedadParaDenegar={this.props.actions.guardarNovedadParaDenegar}
                        obtenerDatosLogIntentos={this.props.actions.obtenerDatosLogIntentos} 
                        parametroGeneral={data.parametroGeneral}
                        nombreCampoModal={data.datosCuentaGenerales.novedadParaDenegar.nombreCampo}
                        modalDenegacionDeCuenta={data.modalDenegacionDeCuenta}
                        ModalDatosCuentaConPunta={modalDatosCuentaConPunta}
                    />

                    <PanelNovedad
                        aceptarCambios={this.props.aceptarCambios}
                        nombreCampo={'GRUPA_CUEN'}
                        data={data.datosCuentaGenerales}
                        tituloCampo={'Grupo de Afinidad'}
                        valorActualDescripcion={NovedadesHelper.AsignarDescripcionPorId(data.datosCuentaGenerales.GruposAfinidadCuenta, data.datosCuentaGenerales.GrupoAfinidadId)}
                        valorActual={data.datosCuentaGenerales.GrupoAfinidadId}
                        novedad={(data.datosCuentaGenerales.novedadesCuentaDatos || []).filter((n) => n.NovedadCampoCodigo == 'GRUPA_CUEN' && ![ 5, 7].some((e) => e == n.NovedadEstadoId))}
                        cambiarEstadoNovedad={this.props.cambiarEstadoNovedad}
                        opciones={data.datosCuentaGenerales.GruposAfinidadCuenta}
                        codigoCampo={'GRUPA_CUEN'}
                        selectCombo={this.props.actions.selectValorCampo}
                        funcionEdicion={this.props.actions.editandoCampoCuenta}
                        guardarNovedad={guardarNovedad}
                        cambiarEstadoNovedad={this.props.actions.actualizarNovedadEstado}
                        muestraBotonHistorial={data.datosCuentaGenerales.novedadesCuentaDatos && data.datosCuentaGenerales.novedadesCuentaDatos.some((n) => n.NovedadCampoCodigo == 'GRUPA_CUEN')}
                        logHistorialCambios={this.props.actions.getLogModificaciones}
                        componenteModificaciones={modalModificaciones}
                        logModificacionesAbierto={data.datosCuentaGenerales.viendoModificacionesCampo == 'GRUPA_CUEN'}
                        seccion={'datosCuentaGenerales'}
                        funcionLimpiarStore={this.props.actions.limpiarStoreComponente}
                        permisoConfirmacion={permisoConfirmacion}
                        permisoModificacion={permisoModificacion}
                        openModal={this.props.actions.openModal}
                        guardarNovedadParaDenegar={this.props.actions.guardarNovedadParaDenegar}
                        obtenerDatosLogIntentos={this.props.actions.obtenerDatosLogIntentos} 
                        parametroGeneral={data.parametroGeneral}
                        nombreCampoModal={data.datosCuentaGenerales.novedadParaDenegar.nombreCampo}
                        modalDenegacionDeCuenta={data.modalDenegacionDeCuenta}
                        ModalDatosCuentaConPunta={modalDatosCuentaConPunta}
                    />
                </div>
            );
        }
        return <div className="loading" />;
    }
}

export default createForm()(DatosGeneralesCuenta);
